var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarboncareLogoLandscapeInverted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 194,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.49998,
    x2: 1.06679,
    y1: 0.49998,
    x1: 0,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93c01f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92bd23",
    offset: 0.154
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fb52f",
    offset: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8aa743",
    offset: 0.458
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83935e",
    offset: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80896c",
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6b705e",
    offset: 0.747
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595b52",
    offset: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4e4e4b",
    offset: 0.919
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a4a49",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    y2: 252.44,
    x2: 212.834,
    y1: 252.44,
    x1: 19.879,
    id: "b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.49998,
    x2: 1.06679,
    y1: 0.49998,
    x1: 0,
    id: "svg_44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93c01f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92bd23",
    offset: 0.154
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fb52f",
    offset: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8aa743",
    offset: 0.458
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.99609,
    stopColor: "#a8bc78",
    offset: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.98828,
    stopColor: "#eefccf",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.98438,
    stopColor: "#f6fce3",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.98828,
    stopColor: "#ffffff",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.99609,
    stopColor: "#e5e5e3",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.99219,
    stopColor: "#ffffff",
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carboncare_logo_landscape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#ffffff",
    d: "m422.633,157.173l-3.457,-5.659c-0.27,0.026 -0.568,0.026 -0.865,0.026l-4.483,0l0,5.633l-3.187,0l0,-18.689l7.672,0c4.835,0 7.616,2.324 7.616,6.377a6,6 0 0 1 -3.916,6.06l4.24,6.247l-3.62,0.005zm-4.32,-8.463c2.918,0 4.592,-1.228 4.592,-3.764c0,-2.456 -1.674,-3.631 -4.592,-3.631l-4.483,0l0,7.4l4.483,-0.005z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#ffffff",
    d: "m449.077,138.484l0,2.831l-10.316,0l0,5.072l9.239,0l0,2.8l-9.235,0l0,5.156l10.635,0l0,2.829l-13.827,0l0,-18.688l13.504,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#ffffff",
    d: "m476.225,147.829c0,5.394 -4.134,9.344 -9.859,9.344l-7.666,0l0,-18.689l7.752,0c5.667,0 9.773,3.926 9.773,9.345zm-3.215,0.027a6.408,6.408 0 0 0 -6.269,-6.543c-0.116,0 -0.232,0 -0.348,0l-4.5,0l0,13.031l4.644,0a6.3,6.3 0 0 0 6.477,-6.12c0,-0.124 0,-0.244 -0.004,-0.368z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#ffffff",
    d: "m492.921,154.477c3.079,0 5,-1.869 5,-5.046l0,-10.947l3.187,0l0,10.947c0,4.883 -3.105,7.872 -8.21,7.872s-8.237,-2.989 -8.237,-7.872l0,-10.947l3.188,0l0,10.947a4.7,4.7 0 0 0 5.075,5.046l-0.003,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#ffffff",
    d: "m519.5,141.208a6.584,6.584 0 1 0 -0.325,13.163c0.109,0 0.217,0 0.325,0a7.866,7.866 0 0 0 5.267,-2.216l1.89,2.082a10.79,10.79 0 0 1 -7.319,3.07a9.532,9.532 0 0 1 -9.825,-9.225c0,-0.093 0,-0.187 0,-0.28c0,-5.312 4.347,-9.4 9.938,-9.4a10.5,10.5 0 0 1 7.184,2.884l-1.864,2.292a7.424,7.424 0 0 0 -5.271,-2.37z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#ffffff",
    d: "m548.808,138.484l0,2.831l-10.316,0l0,5.072l9.236,0l0,2.8l-9.236,0l0,5.156l10.64,0l0,2.829l-13.832,0l0,-18.688l13.508,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#ffffff",
    d: "m585.438,138.484l0,2.831l-10.317,0l0,5.072l9.236,0l0,2.8l-9.236,0l0,5.156l10.64,0l0,2.829l-13.831,0l0,-18.688l13.508,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#ffffff",
    d: "m598.837,138.484l6.239,12.415l6.212,-12.415l3.754,0l0,18.689l-2.942,0l-0.028,-13.962l-5.972,12.013l-2.079,0l-5.969,-12.013l0,13.962l-3,0l0,-18.689l3.785,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#ffffff",
    d: "m628.633,138.484l0,18.689l-3.187,0l0,-18.689l3.187,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#ffffff",
    d: "m644.975,141.315c-1.864,0 -3.079,0.7 -3.079,1.949c0,4.085 10.208,1.893 10.181,8.623c0,3.337 -2.97,5.393 -7.129,5.393a11.7,11.7 0 0 1 -7.724,-2.963l1.377,-2.723a10.026,10.026 0 0 0 6.4,2.723c2.214,0 3.537,-0.828 3.537,-2.269c0,-4.165 -10.207,-1.842 -10.207,-8.49c0,-3.2 2.78,-5.207 6.886,-5.207a12.415,12.415 0 0 1 6.617,1.922l-1.324,2.777a11.389,11.389 0 0 0 -5.535,-1.735z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#ffffff",
    d: "m667.178,141.315c-1.864,0 -3.078,0.7 -3.078,1.949c0,4.085 10.208,1.893 10.18,8.623c0,3.337 -2.97,5.393 -7.129,5.393a11.7,11.7 0 0 1 -7.723,-2.963l1.378,-2.723a10.019,10.019 0 0 0 6.4,2.723c2.214,0 3.538,-0.828 3.538,-2.269c0,-4.165 -10.208,-1.842 -10.208,-8.49c0,-3.2 2.782,-5.207 6.886,-5.207a12.406,12.406 0 0 1 6.617,1.922l-1.323,2.777a11.385,11.385 0 0 0 -5.538,-1.735z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#ffffff",
    d: "m686.6,138.484l0,18.689l-3.187,0l0,-18.689l3.187,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#ffffff",
    d: "m715.452,147.829c0,5.34 -4.375,9.478 -10.019,9.478s-10.02,-4.138 -10.02,-9.478c0,-5.366 4.376,-9.425 10.02,-9.425s10.019,4.085 10.019,9.425zm-16.8,0a6.742,6.742 0 0 0 6.807,6.648a6.623,6.623 0 1 0 -6.807,-6.648z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#ffffff",
    d: "m727.391,138.484l10.128,13.429l0,-13.429l3.132,0l0,18.689l-3.132,0l-10.073,-13.4l0,13.4l-3.188,0l0,-18.689l3.133,0z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#ffffff",
    d: "m757.023,141.315c-1.863,0 -3.078,0.7 -3.078,1.949c0,4.085 10.209,1.893 10.181,8.623c0,3.337 -2.971,5.393 -7.129,5.393a11.7,11.7 0 0 1 -7.723,-2.963l1.377,-2.723a10.021,10.021 0 0 0 6.4,2.723c2.214,0 3.539,-0.828 3.539,-2.269c0,-4.165 -10.209,-1.842 -10.209,-8.49c0,-3.2 2.782,-5.207 6.886,-5.207a12.406,12.406 0 0 1 6.617,1.922l-1.322,2.777a11.385,11.385 0 0 0 -5.539,-1.735z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#ffffff",
    d: "m320.984,122.361c-8.754,0 -13.61,-5.074 -13.61,-13.458l0,-17.309c0,-8.384 4.856,-13.451 13.61,-13.451l36.249,0l0,10.412l-27.016,0c-6.565,0 -8.275,1.893 -8.275,11.7c0,10.277 1.778,11.7 8.275,11.7l27.016,0l0,10.411l-36.249,-0.005z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#ffffff",
    d: "m409.689,122.361l-32.419,0c-9.233,0 -14.093,-4.462 -14.093,-14.266c0,-8.858 4.857,-12.441 14.093,-12.441l28.589,0l0,8.722l-26.059,0c-1.983,0 -3.282,0.608 -3.282,3.786c0,2.773 1.025,3.786 3.214,3.786l20.655,0c6.5,0 8.277,-1.42 8.277,-11.7c0,-9.805 -1.643,-11.7 -8.277,-11.7l-35.081,0l0,-10.407l44.388,0c8.686,0 13.611,5.071 13.611,13.451l0,17.308c-0.005,8.387 -4.93,13.461 -13.616,13.461z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#ffffff",
    d: "m451.065,88.551c-5.814,0 -6.909,1.353 -6.909,7.506l0,26.3l-14.91,0l0,-30.763c0,-8.384 4.857,-13.451 13.611,-13.451l13.611,0l0,10.412l-5.403,-0.004z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#ffffff",
    d: "m508.035,122.361l-33.035,0c-8.755,0 -13.611,-5.071 -13.611,-13.451l0,-38.344l14.911,0l0,33.877c0,6.153 1.094,7.506 6.907,7.506l15.526,0c6.361,0 8.276,-1.42 8.276,-11.63c0,-10.48 -1.915,-11.765 -8.276,-11.765l-20.039,0l0,-10.412l29.341,0c8.686,0 13.542,5.071 13.542,13.451l0,17.307c0,8.387 -4.856,13.461 -13.542,13.461z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#ffffff",
    d: "m574.169,122.361l-33.035,0c-8.755,0 -13.611,-5.071 -13.611,-13.451l0,-17.316c0,-8.384 4.856,-13.451 13.611,-13.451l33.035,0c8.687,0 13.542,5.071 13.542,13.451l0,17.306c0,8.387 -4.855,13.461 -13.542,13.461zm-9.3,-33.807l-14.5,0c-6.567,0 -8.276,1.893 -8.276,11.7c0,10.277 1.778,11.7 8.276,11.7l14.5,0c6.361,0 8.276,-1.285 8.276,-11.7c0,-10.213 -1.913,-11.7 -8.276,-11.7z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#ffffff",
    d: "m639.005,122.361l0,-30.021c0,-3.38 -0.411,-3.786 -3.216,-3.786l-24.006,0c-2.8,0 -3.215,0.406 -3.215,3.786l0,30.021l-14.91,0l0,-44.219l46.642,0c8.754,0 13.61,5.071 13.61,13.451l0,30.768l-14.905,0z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#93c01f",
    d: "m673.475,122.361c-8.755,0 -13.611,-5.071 -13.611,-13.451l0,-17.316c0,-8.384 4.856,-13.451 13.611,-13.451l36.248,0l0,10.412l-27.015,0c-6.567,0 -8.276,1.893 -8.276,11.7c0,10.277 1.778,11.7 8.276,11.7l27.015,0l0,10.411l-36.248,-0.005z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#93c01f",
    d: "m762.176,122.361l-32.42,0c-9.233,0 -14.092,-4.462 -14.092,-14.266c0,-8.858 4.856,-12.441 14.092,-12.441l28.585,0l0,8.722l-26.054,0c-1.983,0 -3.282,0.608 -3.282,3.786c0,2.773 1.025,3.786 3.214,3.786l20.655,0c6.5,0 8.276,-1.42 8.276,-11.7c0,-9.805 -1.642,-11.7 -8.276,-11.7l-35.086,0l0,-10.407l44.388,0c8.686,0 13.61,5.071 13.61,13.451l0,17.308c0,8.387 -4.924,13.461 -13.61,13.461z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#93c01f",
    d: "m803.551,88.551c-5.814,0 -6.908,1.353 -6.908,7.506l0,26.3l-14.91,0l0,-30.763c0,-8.384 4.856,-13.451 13.611,-13.451l13.61,0l0,10.412l-5.403,-0.004z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#93c01f",
    d: "m859.838,104.846l-28.521,0l0,-8.722l25.983,0c1.983,0 3.282,-0.608 3.282,-3.786c0,-2.772 -1.025,-3.786 -3.214,-3.786l-20.648,0c-6.5,0 -8.276,1.488 -8.276,11.765c0,9.737 1.71,11.63 8.276,11.63l35.155,0l0,10.414l-44.384,0c-8.754,0 -13.61,-5.071 -13.61,-13.451l0,-17.316c0,-8.384 4.856,-13.451 13.61,-13.451l32.352,0c9.233,0 14.157,4.462 14.157,14.266c0,8.854 -4.931,12.437 -14.162,12.437z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "url(#svg_44)",
    d: "m168.031,159.32a77.275,77.275 0 0 1 -44.476,14c-2.889,0 -8.379,-0.095 -10.939,-0.347l-0.41,-0.072c-15.745,2.491 -35.094,-0.467 -59.131,-12.4l1.671,2.1c0.56,0.7 13.96,17.346 35.553,25.656a98.772,98.772 0 0 0 108.347,-28.937l-30.615,0z",
    className: "d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#ffffff",
    d: "m227.071,147.325a5.48,5.48 0 1 0 5.538,5.48a5.488,5.488 0 0 0 -5.538,-5.48zm-0.083,7.985a2.51,2.51 0 1 1 2.538,-2.509a2.515,2.515 0 0 1 -2.538,2.509z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    fill: "#ffffff",
    d: "m242.522,149.828a30.152,30.152 0 0 0 -0.3,-6.738l-3.906,-6.031l-3.549,-9.4a5.843,5.843 0 0 0 -5.574,-4.028l-17.554,0a3.442,3.442 0 0 0 -3.461,3.421l0,26.324l11.679,0a6.689,6.689 0 0 1 0.526,-3.018a7.143,7.143 0 0 1 5.889,-4.285a7.044,7.044 0 0 1 7.681,6.336c0.02,0.208 0.03,0.418 0.031,0.627c0,0.116 -0.008,0.229 -0.013,0.343l8.751,0a0.731,0.731 0 0 0 0.728,-0.64l0.155,-1.3a1.739,1.739 0 0 0 -1.083,-1.611zm-28.456,-14.028l0,-10.348l9.346,0l1.731,10.352l-11.077,-0.004zm13.846,-0.342l-1.731,-9.782l3.256,0a2.566,2.566 0 0 1 2.476,1.856l2.706,7.926l-6.707,0z",
    className: "b"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_29",
    fill: "#ffffff",
    points: "164.466 151.332 205.215 151.332 205.215 120.269 193.164 120.269 164.466 151.332",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    fill: "#93c01f",
    d: "m0,114.049s20.4,24.345 51.242,38.75c87.172,40.716 125.975,-43.919 135.505,-61.876c-3.927,1.9 -55.1,22.935 -85.483,26.1c-41.257,4.289 -61.875,-0.451 -61.875,-0.451s58.1,-1.712 111.889,-24.88c-36.634,-34.779 -73.587,-24.453 -99.356,-2.172c-25.564,22.106 -51.922,24.529 -51.922,24.529z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    fill: "none",
    d: "m256.942,86.2c1.051,0.062 1.966,-1.046 2.042,-2.474s-0.715,-2.634 -1.767,-2.7s-1.967,1.045 -2.042,2.473s0.715,2.637 1.767,2.701z",
    className: "e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    fill: "url(#b)",
    d: "m210.5,52.139a98.56,98.56 0 0 0 -175.5,3.152l-15.12,-5.235l7.908,49.064l43.512,-34.475l-15.066,-4.9a77.585,77.585 0 0 1 123.549,-14.945l24.5,5.855l6.217,1.484z",
    className: "f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    fill: "#ffffff",
    d: "m258.063,46.5c-3.782,-1.962 -9.388,-2.975 -19.1,-0.369s-72.563,24.642 -72.563,24.642c-3.177,-0.177 -13.383,-7.4 -13.383,-7.4s-8.2,0.941 -7.864,1.31c1.178,1.3 12.272,20.634 14.992,22.536c1.225,0.855 4.215,0.586 10.686,-1.151s33.933,-11.4 33.933,-11.4l-10.8,40.342s7.882,-1.659 10.925,-5.339c2.715,-3.288 18.4,-36.2 21.746,-43.264c8.51,-3.7 18.63,-8.077 21.616,-9.257c5.433,-2.145 8.317,-3.034 10.926,-5.337s2.668,-3.35 -1.114,-5.313z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    fill: "#ffffff",
    d: "m186.044,59.556l17.338,-6.031l-34.356,-8.211a8.7,8.7 0 0 0 -3.987,-0.011c-2.843,0.66 -7.5,1.809 -5.9,1.9c1.061,0.058 26.905,12.353 26.905,12.353z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    fill: "none",
    d: "m234.541,109.594c-4.046,-4.008 -13.059,-5.6 -22.367,-6.078c-0.832,1.595 -1.593,3.024 -2.261,4.231a42.8,42.8 0 0 1 24.628,1.847z",
    className: "e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    fill: "none",
    d: "m256.945,86.192c1.051,0.062 1.965,-1.046 2.041,-2.474s-0.714,-2.635 -1.766,-2.7s-1.967,1.046 -2.043,2.474s0.715,2.638 1.768,2.7z",
    className: "e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_37",
    fill: "#ffffff",
    d: "m186.681,102.62s3.274,-0.4 7.971,-0.672l1.281,-4.783a55.207,55.207 0 0 0 -9.252,5.455z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_38",
    fill: "#ffffff",
    d: "m251.369,113.8l19.231,-40.341s-26.094,6.008 -50.608,14.448c-2.765,5.657 -5.546,11.249 -7.818,15.612c9.308,0.475 18.321,2.067 22.367,6.078a42.8,42.8 0 0 0 -24.628,-1.844c-0.631,1.141 -1.178,2.083 -1.618,2.775c-0.749,1.384 -1.525,2.753 -2.356,4.085a43.4,43.4 0 0 1 29.851,4.008c33.2,17.63 43.288,-4.407 43.288,-4.407a22.434,22.434 0 0 1 -27.709,-0.414zm5.851,-32.771c1.052,0.062 1.842,1.269 1.766,2.7s-0.99,2.536 -2.041,2.474s-1.843,-1.269 -1.768,-2.7s0.991,-2.544 2.043,-2.477l0,0.003z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    id: "svg_39",
    fill: "#ffffff",
    d: "m246.343,75.666c3.118,-0.87 6.054,-1.664 8.719,-2.367l0,-1.825l-8.719,-2.821l0,7.013z",
    className: "g"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    id: "svg_40",
    fill: "#ffffff",
    d: "m235.026,72.205l0,2.978l-2.726,-0.883l0,5.474q1.372,-0.423 2.729,-0.83q1.983,-0.6 3.919,-1.163c2.347,-0.688 4.629,-1.34 6.827,-1.955l0,-6.985l-10.749,3.364z",
    className: "g"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fillOpacity: 0,
    id: "svg_41",
    fill: "#ffffff",
    d: "m225.548,76.421q-0.818,1.7 -1.683,3.5l-0.2,0.406c-0.413,0.858 -0.835,1.729 -1.259,2.605q0.63,-0.21 1.259,-0.418q1.561,-0.513 3.12,-1.013q2.552,-0.818 5.074,-1.594l0,-5.463l-6.311,1.977z",
    className: "g"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarboncareLogoLandscapeInverted);
export default __webpack_public_path__ + "static/media/carboncare_logo_landscape_inverted.71d602df4ea9a654c9cce4e0293aab0b.svg";
export { ForwardRef as ReactComponent };